export class PageBuilder {
  constructor(public readonly total: number, public readonly limit: number) {}

  public generate(): number[] {
    const pages =
      this.total > this.limit ? Math.ceil(this.total / this.limit) : 1;
    return [...new Array(pages)].map((_, i) => i + 1);
  }
}
